import { Month } from './type'

export const monthOptions = () => {
  const months: Month[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  return months.map((m) => ({
    label: m,
    value: m,
  }))
}
